export const languageNameConstants = {
  pl: "Polski",
  en: "English",
  de: "Deutsch",
  es: "Español",
  uk: "Українська",
  fr: "French"
};
export const languageConstants = Object.keys(languageNameConstants)

